import { render, staticRenderFns } from "./AbaDeCertificadosDoIrmao.vue?vue&type=template&id=6f2717a1"
import script from "./AbaDeCertificadosDoIrmao.vue?vue&type=script&setup=true&lang=ts"
export * from "./AbaDeCertificadosDoIrmao.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports